import React from 'react'

/**
 * Field — label + control wrapper. Renders a small medium-weight label
 * above its children and an optional hint below.
 */
export function Field({ label, hint, className = '', children }) {
  const cls = ['field', className].filter(Boolean).join(' ')
  return (
    <label className={cls}>
      {label && <span>{label}</span>}
      {children}
      {hint && <span className="field-hint">{hint}</span>}
    </label>
  )
}
